import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import dots from "../assets/dots.svg";
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from "react-router-dom";
const Account = () => {
    const [activeTab, setActiveTab] = useState("user");
    return (
        <>
            <PageHeader pageTitle="Account" is_deploy_enable={false}>
                <Link to="/account/create-new-account" className="btn-black">
                    Create New User
                </Link>
            </PageHeader>

            <div className="page-container">
                <div className="role-header mb-4">
                    <div className="role-tabs">
                        <Link to="/account" className="role-tab active">Users</Link>
                        <Link to="/role" className="role-tab">Roles</Link>
                    </div>

                </div>
                <div className="theme-card p-4">
                    <div className="d-flex align-items-center mb-3">
                        <div className="card-title pb-3">Users</div>
                        <div className="sel-box ms-auto">
                            <select name="selmenu" id="selmenu" className="theme-select">
                                <option value="">Filter</option>
                                <option value="">Filter Options</option>
                            </select>
                        </div>
                    </div>
                    <table className="pages-table">
                        <thead>
                            <tr>
                                <th>User name</th>
                                <th>User ID</th>
                                <th>Email</th>
                                <th>Mobile number</th>
                                <th>Default role</th>
                                <th>Date created</th>
                                <th>Access</th>
                                <th className="text-end" width="10%">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Jon Doe</td>
                                <td>ID0370</td>
                                <td>johndeo@gmail.com</td>
                                <td>+91 9876543210</td>
                                <td>Admin</td>
                                <td>2026/02/20 at 05:30 pm</td>
                                <td>
                                    <span className="status success">Active</span>
                                </td>
                                <td className="text-end" width="10%">
                                    <Dropdown align="end">
                                        <Dropdown.Toggle variant="button">
                                            <button className="dotbtn">
                                                <img src={dots} alt="" />
                                            </button>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="sm">
                                            <Dropdown.Item as={Link} to="/account/edit-account">Edit</Dropdown.Item>
                                            <Dropdown.Item as={Link} to="#" className="text-success">Activate</Dropdown.Item>
                                            <Dropdown.Item as={Link} to="#" className="text-danger">Deactivate</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default Account